import React, { Component } from 'react';
import './Product.scss'

class Products extends Component {
    render() {
        return (
            <>
                <div id='products' className='product_section py-5'>
                    <div className='container'>
                        <div className='row justify-content-center pt-5'>
                            <h2 className='text_1_white'>Our API Suite</h2>
                        </div>
                        <div className='row justify-content-center pt-2'>
                            <h3 className='text_2_white'>For FinTechs & Robos</h3>
                        </div>
                        <div class="row justify-content-center py-5">
                            <div class="col-md-4  col-sm-6  py-3 d-flex align-items-center content_center">
                                <div className='fa_icon_box d-flex'>
                                    <image className = " fa fa-user-circle"></image>
                                </div>
                                <span className='product_name ml-3'>KYC Check</span>
                            </div>
                            <div class="col-md-4  col-sm-6  py-3 d-flex align-items-center content_center">
                            <div className='fa_icon_box d-flex'>
                                    <image className = "fa fa-users"></image>
                                </div>
                                <span className='product_name ml-3'>Client On-Boarding</span>
                            </div>
                            <div class="col-md-4  col-sm-6  py-4 d-flex align-items-center content_center">
                            <div className='fa_icon_box d-flex'>
                                    <image className = " fa fa-file"></image>
                                </div>
                                <span className='product_name ml-3'>RTA File Processing</span>
                            </div>
                            <div class="col-md-4  col-sm-6  py-4 d-flex align-items-center content_center">
                            <div className='fa_icon_box d-flex'>
                                    <image className = "fa fa-copy"></image>
                                </div>
                                <span className='product_name ml-3'>E Cas Reading</span>
                            </div>
                            <div class="col-md-4  col-sm-6  py-4 d-flex align-items-center content_center">
                            <div className='fa_icon_box d-flex'>
                                    <image className = "fa fa-shield"></image>
                                </div>
                                <span className='product_name ml-3'>Risk Profiler</span>
                            </div>
                            <div class="col-md-4  col-sm-6  py-4 d-flex align-items-center content_center">
                            <div className='fa_icon_box d-flex'>
                            <image class="fa fa-file-text-o"></image>
                                </div>
                                <span className='product_name ml-3'>Portfolio Reporting</span>
                            </div>
                            <div class="col-md-4  col-sm-6  py-4 d-flex align-items-center content_center">
                            <div className='fa_icon_box d-flex'>
                                    <image className = "fa fa-calendar"></image>
                                </div>
                                <span className='product_name ml-3'>Goal Planning</span>
                            </div>
                            <div class="col-md-4  col-sm-6  py-4 d-flex align-items-center content_center">
                            <div className='fa_icon_box d-flex'>
                                    <image className = "fa fa-exchange"></image>
                                </div>
                                <span className='product_name ml-3'>Transactions - MF</span>
                            </div>
                            <div class="col-md-4  col-sm-6  py-4 d-flex align-items-center content_center">
                            <div className='fa_icon_box d-flex'>
                                    <image className = "fa fa-pie-chart"></image>
                                </div>
                                <span className='product_name ml-3'>Mutual Fund Data</span>
                            </div>
                            <div class="col-md-4  col-sm-6  py-4 d-flex align-items-center content_center">
                            <div className='fa_icon_box d-flex'>
                                    <image className = "fa fa-bar-chart"></image>
                                </div>
                                <span className='product_name ml-3'>Model Portfolios</span>
                            </div>
                            <div class="col-md-4  col-sm-6  py-4 d-flex align-items-center content_center">
                            <div className='fa_icon_box d-flex'>
                                    <image className = "fa fa-building"></image>
                                </div>
                                <span className='product_name ml-3'>Multi Assets</span>
                            </div>
                            <div class="col-md-4  col-sm-6  py-4 d-flex align-items-center content_center">
                            <div className='fa_icon_box d-flex'>
                                    <image className = "fa fa-line-chart"></image>
                                </div>
                                <span className='product_name ml-3'>Portfolio Analytics</span>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}


export default Products